var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPractice3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59 46",
    style: {
      enableBackground: "new 0 0 59 46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.4069,
    y1: 23,
    x2: 58.5931,
    y2: 23
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001058023,
    style: {
      stopColor: "#5DB696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9963,
    style: {
      stopColor: "#4097D1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56,25.6c2.4-3.7,2.8-6.9,2.5-9.2C57.4,6.9,50.7,0.3,42.3,0.2c-4-0.1-7.9,1.5-10.9,4.2c-3-2.6-6.9-4.1-10.8-4.1 c-0.1,0-0.1,0-0.1,0C11.5,0.4,4.4,7.6,4.2,16.7c-0.1,1.7,0.3,3.5,1,5.3H0.4v2.4h5.9c1.4,2.5,3.5,5.1,6.3,7.6 c0.1,0.1,0.1,0.1,0.2,0.2l16.8,12.9c0.5,0.4,1.1,0.7,1.7,0.7c0.6,0,1.1-0.2,1.7-0.5l16.9-13l0.2-0.1c0.1-0.1,0.1-0.1,0.2-0.2 c1.5-1.3,2.8-2.6,3.8-3.8l4.4-0.3l-0.1-2.4L56,25.6z M48.7,30.1c-0.2,0.1-0.3,0.2-0.4,0.3L31.5,43.3c-0.1,0.1-0.3,0.1-0.4,0 L14.4,30.5c-0.1-0.1-0.2-0.2-0.3-0.3c-2.1-2-3.8-3.9-5.1-5.9h8.3l5.9-11.8l5.6,20.2L37,22.2l2,6.8l11.6-0.7 C50,28.9,49.3,29.5,48.7,30.1z M52.8,25.8l-12.2,0.8l-2.7-9.5l-8,10.5L23.9,6l-8,16H7.8c-0.8-1.8-1.2-3.5-1.2-5.3 c0.2-7.8,6.3-13.9,13.9-14h0.1c3.7,0,7.3,1.5,9.9,4.1l0.8,0.8l0.8-0.8c2.7-2.7,6.3-4.3,10-4.3h0.1c7.2,0.1,12.9,5.9,13.9,14.1 C56.4,19.6,55.3,22.6,52.8,25.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPractice3);
export default __webpack_public_path__ + "static/media/icon_practice3.a68eb4f70cc283691874850985c4d594.svg";
export { ForwardRef as ReactComponent };